<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-form
            ref="form"
            v-model="mainInfoStep"
    >
        <v-card class="mb-10 pt-3 border-transparent min-card-height" outlined>
            <v-row>
                <v-col class="mobile-col" xs="6">
                    <div class="d-flex align-center justify-center px-4">
                        <multiple-image-input @value-change="imagesValue"></multiple-image-input>
                    </div>
                </v-col>
                <v-col class="mobile-col" xs="6">
                    <div class="mobile-padding">
                        <v-autocomplete
                                v-model="stepData.mainCategory"
                                :items="mainCategoryData"
                                hide-no-data
                                item-text="name"
                                item-value="id"
                                return-object
                                :label="$t('section')"
                                @change="changeMainCategory"
                                cache-items
                                flat
                                class="width-300 pa-0 ma-0"
                                color="orange lighten-2"
                                :rules="rules"
                                required
                                clearable
                        ></v-autocomplete>
                        <v-autocomplete
                                v-model="stepData.category"
                                :items="categoriesData"
                                hide-no-data
                                item-text="name"
                                item-value="id"
                                return-object
                                :label="$t('category')"
                                flat
                                class="width-300 pa-0 ma-0"
                                color="orange lighten-2"
                                :rules="rules"
                                required
                                clearable
                                @change="changeCategory"
                        ></v-autocomplete>
                        <v-autocomplete
                                v-model="stepData.manufacturer"
                                :items="manufacturersData"
                                hide-no-data
                                item-text="name"
                                item-value="id"
                                return-object
                                :label="$t('producer')"
                                flat
                                class="width-300 pa-0 ma-0"
                                color="orange lighten-2"
                                :rules="rules"
                                required
                                clearable
                        ></v-autocomplete>
                    </div>
                </v-col>
                <v-col cols="12" class="d-flex pt-0 justify-center">
                    <div v-for="image in stepData.initialImages" :key="image.id" style="position: relative">
                        <v-img :src="image.url" width="80px" class="mx-2 initial-image elevation-2"></v-img>
                        <v-icon color="white" class="remove-icon" size="24" @click="showDeleteSnack(image.id)">close</v-icon>
                    </div>
                </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-card-title class="px-8 py-4 subtitle-2 ">{{$t('mainInfo')}}</v-card-title>
            <v-row class="pa-0 px-8">
                <v-col class="mobile-col pa-0  d-flex flex-wrap" sm="12" md="12" lg="12">
                    <v-col cols="12" sm="4" class="mobile-col">
                        <v-text-field
                                class="width-300 pt-0"
                                :label="$t('nameRu')"
                                v-model="stepData.productNameRu"
                                color="orange lighten-2"
                                :rules="rules"
                                required
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="4" class="mobile-col">
                        <v-text-field
                                class="width-300 pt-0"
                                :label="$t('nameUa')"
                                v-model="stepData.productNameUa"
                                color="orange lighten-2"
                                :rules="rules"
                                required
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="4" class="mobile-col">
                        <v-text-field
                                class="width-300 pt-0"
                                :label="$t('articleNumber')"
                                v-model="stepData.articleNumber"
                                color="orange lighten-2"
                        ></v-text-field>
                    </v-col>
                </v-col>
            </v-row>
            <v-row class="pa-0 px-8">
                <v-col class="mobile-col py-0 d-flex" sm="6">
                    <v-autocomplete
                            v-model="stepData.packingType"
                            :items="packingTypeData"
                            hide-no-data
                            item-text="name"
                            item-value="id"
                            return-object
                            :label="$t('packing')"
                            flat
                            class="width-300 ma-0"
                            color="orange lighten-2"
                            :rules="rules"
                            required
                            clearable
                    ></v-autocomplete>
                </v-col>
                <v-col class="mobile-col py-0 d-flex" sm="6">
                    <v-row class="body-2 pa-0">
                        <v-col sm="5" class=" pl-0">
                            <v-text-field
                                    v-model="stepData.packingQuantity"
                                    :label="$t('quantity')"
                                    :rules="rules"
                                    required
                                    color="orange lighten-2"
                            ></v-text-field>
                        </v-col>
                        <v-col sm="7" class="">
                            <v-autocomplete
                                    v-model="stepData.quantityUnits"
                                    :label="$t('unitOfMeasure')"
                                    :items="quantityUnitsData"
                                    hide-no-data
                                    item-text="name"
                                    item-value="id"
                                    return-object
                                    flat
                                    color="orange lighten-2"
                                    :rules="rules"
                                    required
                                    clearable
                            ></v-autocomplete>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-card-title class="pt-4 px-8 subtitle-2">{{$t('dimensions')}}</v-card-title>
            <v-row class="pa-0 px-8">
                <v-col cols="6" class="col-md-3">
                    <v-text-field
                        v-model="stepData.packLength"
                        color="orange lighten-2"
                        dense
                        outlined
                        :label="`${$t('length')}, ${$t('m')}`"
                    ></v-text-field>
                </v-col>
                <v-col cols="6" class="col-md-3">
                    <v-text-field
                        v-model="stepData.packWidth"
                        color="orange lighten-2"
                        dense
                        outlined
                        :label="`${$t('width')}, ${$t('m')}`"
                    ></v-text-field>
                </v-col>
                <v-col cols="6" class="col-md-3">
                    <v-text-field
                        v-model="stepData.packHeight"
                        color="orange lighten-2"
                        dense
                        outlined
                        :label="`${$t('height')},  ${$t('m')}`"
                    ></v-text-field>
                </v-col>
                <v-col cols="6" class="col-md-3">
                    <v-text-field
                        v-model="stepData.packWeight"
                        color="orange lighten-2"
                        dense
                        outlined
                        :label="`${$t('weight')}, ${$t('kg')}`"
                    ></v-text-field>
                </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-card-title class="px-8 pt-4 pb-0 subtitle-2 ">{{ $t('minOrder') }}</v-card-title>
            <v-row class="pa-0 px-8">
                <v-col class="mobile-col d-flex" cols="12">
                    <v-row class="body-2 pa-0">
                        <v-col cols="6" class="pt-5">
                            <v-text-field
                                    v-model="stepData.minValueQuantity"
                                    :label="$t('quantity')"
                                    color="orange lighten-2"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="6" class="pt-5">
                            <v-autocomplete
                                    v-model="stepData.packingType"
                                    :items="packingTypeData"
                                    :disabled="isPackByDisabled"
                                    hide-no-data
                                    item-text="name"
                                    item-value="id"
                                    return-object
                                    :label="$t('packedBy')"
                                    flat
                                    class="width-300 ma-0"
                                    color="orange lighten-2"
                            ></v-autocomplete>
                        </v-col>
                    </v-row>
                    <v-tooltip
                            top
                            fixed
                            max-width="500"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon
                                    color="grey"
                                    dark
                                    v-bind="attrs"
                                    v-on="on"
                            >info</v-icon>
                        </template>
                        <span>{{$t('minimumOrderHelp')}}</span>
                    </v-tooltip>
                </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-card-title class="px-8 pt-4 pb-0 subtitle-2">
                {{ $t('price') }} {{ $t('for') }} {{ selectedUnits ? '1 ' + selectedUnits : '' }}
            </v-card-title>
            <v-row class="pa-0 px-8">
                <v-col class="mobile-col" cols="12" md="4">
                    <v-text-field
                            v-model="stepData.price"
                            :label="stepData.currency.name"
                            color="orange lighten-2"
                            dense
                            outlined
                            :rules="rules"
                            requred
                    ></v-text-field>
                    <v-text-field
                        dense
                        outlined
                        disabled
                        :value="totalPrice"
                        :label="`${ $t('price') } ${ $t('for') } ${ minimumPackingType || '' }`"
                    ></v-text-field>
                </v-col>
                <v-col class="d-flex align-baseline" cols="12" md="4">
                    <v-select
                            v-model="stepData.currency"
                            :items="currencies"
                            hide-no-data
                            dense
                            item-text="name"
                            item-value="id"
                            return-object
                            :label="$t('currency')"
                            flat
                            class="ma-0"
                            color="orange lighten-2"
                            :rules="rules"
                            required
                            outlined
                    ></v-select>
                </v-col>
                <v-col class="d-flex justify-start justify-md-end pt-0 pt-md-4" cols="12" md="4">
                    <v-checkbox
                        class="mt-0"
                        v-model="stepData.withNds"
                        :label="$t('withNds')"
                        color="orange lighten-2"
                        @change="ndsChange"
                    ></v-checkbox>
                </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-card-title class="px-8 pt-4 pb-0 subtitle-2 ">{{ $t('priceWithDiscount') }}</v-card-title>
            <v-row class="pa-0 px-8">
                <v-col class="mobile-col" cols="12" md="4">
                    <v-text-field
                        v-model="discountPrice"
                        :label="stepData.currency.name"
                        color="orange lighten-2"
                        dense
                        outlined
                        requred
                    ></v-text-field>
                </v-col>
                <v-col class="mobile-col" cols="12" md="4">
                    <v-text-field
                        v-model="stepData.discountPercent"
                        disabled
                        :label="$t('discountInPercent')"
                    ></v-text-field>
                </v-col>
            </v-row>
        </v-card>
        <div class="d-flex justify-space-between">
            <v-btn
                    outlined
                    dark
                    class="caption text--main-yellow "
                    justify="center"
                    width="130"
                    disabled
            >{{$t('back')}}</v-btn>
            <v-btn
                    depressed
                    class="caption white--text main--yellow"
                    width="130"
                    :disabled="!mainInfoStep"
                    @click="validate"
            >{{$t('next')}}</v-btn>
        </div>
        <v-snackbar :color="snackColor" v-model="snackOpen">
            {{ $t('remove') }} ?
            <div>
                <v-btn text class="text--main-yellow" @click="removeImage">{{ $t('yes') }}</v-btn>
                <v-btn text icon @click="snackOpen = false">
                    <v-icon color="grey">close</v-icon>
                </v-btn>
            </div>
        </v-snackbar>
    </v-form>
</template>

<script>
    import './product-add.scss'

    import InfoService from '../../../../app-front/services/api/InfoService';
    import AppSnack from '../../../../general/mixins/AppSnack';
    import MultipleImageInput from '../../../../general/image/multiple-image-input';
    import ProductUpdateInitial from '../../../../app-front/mixins/ProductUpdateInitial';
    import {Decimal} from 'decimal.js';
    import { normalizeFloat } from '../../../../utils';


    export default {
        name: "MainInfoStep",
        mixins: [AppSnack, ProductUpdateInitial],
        components:{MultipleImageInput},
        data() {
            return {
                attributesValues: {},
                metaUrl: '/products/add',
                steps: 1,
                rules: [value => !!value || this.$t('requiredField')],
                mainInfoStep: false,
                stepData: {
                    articleNumber: '',
                    category: null,
                    currency: this.$store.state.currency[0],
                    discountPercent: null,
                    mainCategory: null,
                    manufacturer: null,
                    minimumOrder: null,
                    minValueQuantity: null,
                    minValueType: null,
                    packingQuantity: null,
                    packingType: null,
                    packLength: null,
                    packWidth: null,
                    packHeight: null,
                    packWeight: null,
                    price: null,
                    initialImages: [],
                    productImages: [],
                    productNameRu: null,
                    productNameUa: null,
                    quantityUnits: null,
                },
                discountPrice: '',
                productCharacteristics:[],
                mainCategoryData:[],
                categoriesData: [],
                manufacturersData: [],
                packingTypeData: [],
                quantityUnitsData: [],
                selectItems: [],
                imageRemoved: null
            }
        },
        computed: {
            currencies() {
                return this.$store.state.currency;
            },
            isPackByDisabled() {
                return !!this.stepData.packingType;
            },
            minimumPackingType() {
                return this.stepData.packingType ? this.stepData.packingType.name : null;
            },
            selectedUnits() {
                return this.stepData.quantityUnits ? this.stepData.quantityUnits.name : null;
            },
            discountPercent() {
                let one = new Decimal(1);
                return one.minus(this.discountPrice/this.stepData.price).times(100).toNumber();
            },
            totalPrice() {
                const { packingQuantity, price } = this.stepData;
                const normalizedPrice = normalizeFloat(price);

                return !Number.isNaN(+packingQuantity) && !Number.isNaN(+normalizedPrice)
                    ? +packingQuantity * +normalizedPrice
                    : 0;
            },
        },
        methods: {
            changeCategory() {
                this.$emit('category-change', this.stepData.category ? this.stepData.category.id : null)
            },
            changeMainCategory() {
                const categoryId = this.stepData.mainCategory ? this.stepData.mainCategory.id : 0;

                if(!categoryId) {
                    this.stepData.category = null;

                    return false;
                }

                InfoService.setLocale(this.$store.state.language.appLanguage);
                InfoService.getSubCategories(categoryId)
                    .then(res => {
                        this.categoriesData = res.data;
                    })
                    .catch(err => console.log(err));

                InfoService.getCategoryManufacturers(categoryId)
                    .then(res => {
                        this.manufacturersData = res.data;
                    })
                    .catch(err => console.log(err));

                InfoService.getCategoryPacks(categoryId)
                    .then(res => {
                        this.packingTypeData = res.data;
                    })
                    .catch(err => console.log(err));

                InfoService.getQuantityUnits()
                    .then(res => {
                        this.quantityUnitsData = res.data;
                    })
                    .catch(err => console.log(err));

            },
            imagesValue(data) {
                this.stepData.productImages = data;
            },
            ndsChange(data) {
                this.stepData.withNds = data;
            },
            remove(item) {
                const index = this.selectItems.indexOf(item);
                if (index >= 0) this.selectItems.splice(index, 1)
            },
            removeImage() {
                this.$emit('remove-image', this.imageRemoved);
                this.snackOpen = false;
                this.imageRemoved = null;
            },
            showDeleteSnack(id) {
                this.imageRemoved = id;
                this.resetSnack();
                this.setDeleteSnack();
                this.openSnack();
            },
            setInitialData() {
                this.setMainInfoInitial();
            },
            setMainCategories() {
                InfoService.setLocale(this.$store.state.language.appLanguage);
                InfoService.getMainCategories()
                    .then(res => {
                        this.mainCategoryData = res.data;
                    })
                    .catch(err => console.log(err))
            },
            validate() {
                if (this.$refs.form.validate()) {
                    this.$emit('validated', this.stepData)
                }
            },
        },
        created() {
            this.setMainCategories();
            if (this.discountPrice.length === 0) {
                this.stepData.discountPercent = 0
            }
        },
        watch:{
            isUpdating (val) {
                if (val) {
                    setTimeout(() => (this.isUpdating = false), 3000)
                }
            },
            discountPrice(newVal) {
                if (newVal.length === 0) {
                    this.stepData.discountPercent = 0
                } else {
                    let one = new Decimal(1);
                    this.stepData.discountPercent = one.minus(newVal/this.stepData.price).times(100).toNumber();
                }
            }
        },
    }
</script>
<style scoped>
    .initial-image {
        cursor: pointer;
    }
    .remove-icon {
        position: absolute;
        top: 35%;
        right: 0;
        left: 0;
        margin: auto;
        cursor: pointer;
    }
</style>
